import React from "react";
import "./styles/App.css";
import CaRoutes from "./components/routes/CaRoutes";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";

function AppCa() {
  const customTheme = createTheme({
    palette: {
      primary: {
        light: "#b2dfdb",
        main: "#0060a6",
        dark: "#004d40",
      },
      secondary: {
        main: "#f78f2d",
      },
    },
  });

  return (
    <ThemeProvider theme={customTheme}>
      <div className="App">
        <CaRoutes />
      </div>
    </ThemeProvider>
  );
}

export default AppCa;
